import React, {FC, useState} from "react";
import {useTranslate} from "@tolgee/react";
import {IconButton, Tooltip} from "@material-ui/core";
import {useSelector} from "react-redux";
import {selectIsImpersonating} from "store/auth/selectors";
import SettingsIcon from "view/images/SettingsIcon";
import TwoFactorSettingsModal from "view/components/TwoFactorSettingsModal";
import useStyles from "./styles";

type Props = {
  iconColor?: string;
};

const SettingsButton: FC<Props> = ({iconColor}) => {
  const classes = useStyles();
  const {t} = useTranslate();
  const [open, setOpen] = useState(false);
  const isImpersonating = useSelector(selectIsImpersonating);

  // This button exists only to open the 2FA settings modal, and 2FA
  // management is off-limits while viewing as another user — the API answers
  // 403 on the whole surface (`@DenyImpersonatedSession()`), so the gear
  // would only lead to an empty, erroring modal. Guarded here rather than at
  // the two call sites (AppBar, ShowBar/UserDetails) so every present and
  // future usage is covered.
  if (isImpersonating) {
    return null;
  }

  return (
    <>
      <Tooltip
        title={t("common.two_factor.settings_tooltip")}
        placement="bottom"
      >
        <IconButton
          id="settings"
          className={classes.settingsButton}
          onClick={() => setOpen(true)}
        >
          <SettingsIcon fill={iconColor || "#757575"} />
        </IconButton>
      </Tooltip>
      {open && (
        <TwoFactorSettingsModal open={open} onClose={() => setOpen(false)} />
      )}
    </>
  );
};

export default SettingsButton;
